import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.format()
  }

  format() {
    const digits = this.element.value.replace(/\D/g, "")
    const cents = Number.parseInt(digits || "0", 10)

    this.element.value = this.formatCents(cents)
  }

  formatCents(cents) {
    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100)
  }
}
